import baseScmService from 'services/baseScmService';

const lectureContentService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    updateLectureContent: build.mutation({
      query: ({ academyTopicId, content }) => ({
        method: 'PUT',
        url: `lecture-contents/${content.id}`,
        body: { lecture_content: content },
      }),
      invalidatesTags: (result, error, { academyTopicId }) =>
        error ? [] : [{ type: 'AcademyTopic', id: academyTopicId }],
    }),
    createLectureContent: build.mutation({
      query: ({ academyTopicId, content }) => ({
        method: 'POST',
        url: 'lecture-contents/',
        body: {
          lecture_content: {
            ...content,
            academy_topic_id: academyTopicId,
          },
        },
      }),
      invalidatesTags: (result, error, { academyTopicId }) =>
        error ? [] : [{ type: 'AcademyTopic', id: academyTopicId }],
    }),
    deleteLectureContent: build.mutation({
      query: ({ academyTopicLectureContentId, academyTopicId }) => ({
        method: 'DELETE',
        url: `academy-topic-lecture-contents/${academyTopicLectureContentId}`,
      }),
      invalidatesTags: (result, error, { academyTopicId }) =>
        error ? [] : [{ type: 'AcademyTopic', id: academyTopicId }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateLectureContentMutation,
  useDeleteLectureContentMutation,
  useUpdateLectureContentMutation,
} = lectureContentService;

export default lectureContentService;
